// removed by extract-text-webpack-plugin
module.exports = {"fan":"GgZ6naqgNSN6U67iYC3K","myfirst":"_1TBTIAkSwn-PRZxv0g2VcX","chu":"_22xRmMgkRb5akUwcUR3knS","my":"e4kCTHaWsrPNLlMOG5N1"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/FlipCard/FlipCard.scss
 ** module id = 969
 ** module chunks = 0
 **/